export const specialSymbol = /['"\- ;\/]/g;
export const dateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/;
export const emailRegEx = /\S+@\S+\.\S+/;